import { c as _c } from "react/compiler-runtime";
import { useTranslation } from '@/hooks/use-translation';
import { cn } from '@/lib/utils';
import { Button } from '../ui/button';
import { useSidebar } from '../ui/sidebar';
import { Menu } from 'lucide-react';

/**
 * The handle that brings the navigation back.
 *
 * On a phone the sidebar is a drawer and the handle is always needed. On a
 * desktop the sidebar is part of the page, so the handle stays out of the
 * way — until someone folds the sidebar away with ⌘B, which is the one state
 * the design has no other way out of. On a phone it is the only door to
 * the navigation, so it gets a fingertip's 44 px, as the mobile mockup does.
 */
export const AppSidebarTrigger = t0 => {
  const $ = _c(21);
  let className;
  let onClick;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onClick;
    $[3] = props;
  } else {
    className = $[1];
    onClick = $[2];
    props = $[3];
  }
  const {
    isMobile,
    openMobile,
    state,
    toggleSidebar
  } = useSidebar();
  const {
    t
  } = useTranslation();
  const t1 = isMobile ? openMobile : state === "expanded";
  const t2 = !isMobile && state === "expanded" && "hidden";
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn("size-11 print:hidden lg:size-7", t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClick || $[8] !== toggleSidebar) {
    t4 = event => {
      onClick?.(event);
      toggleSidebar();
    };
    $[7] = onClick;
    $[8] = toggleSidebar;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Menu />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("Navigation", {
      ns: "navigation"
    });
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <span className="sr-only">{t6}</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props || $[16] !== t1 || $[17] !== t3 || $[18] !== t4 || $[19] !== t7) {
    t8 = <Button data-sidebar="trigger" data-slot="sidebar-trigger" variant="ghost" size="icon" aria-expanded={t1} className={t3} onClick={t4} {...props}>{t5}{t7}</Button>;
    $[15] = props;
    $[16] = t1;
    $[17] = t3;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};